import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachekylinComponent } from './simple-icons-apachekylin.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachekylinComponent ],
    exports:      [ SimpleIconsApachekylinComponent ],
    bootstrap:    []
})
export class SimpleIconsApachekylinModule {}
